import { useAtomValue } from 'jotai';
import { dashboardAccountAtom } from 'src/atoms/filters/dashboard';
import { useAuth } from 'src/auth/hooks/useAuth';
import { useIsCslUser } from 'src/auth/hooks/useIsCslUser';

export const useDashboardAccountRef = () => {
  const { user } = useAuth();
  const isCSLUser = useIsCslUser();

  const accountRef = useAtomValue(dashboardAccountAtom);

  return isCSLUser ? accountRef : user.referenceId;
};
